/** Счётчик Яндекс.Метрики для ai.cleverence.ru */
export const YANDEX_METRIKA_COUNTER_ID = 28939035;

declare global {
  interface Window {
    ym?: YmFunction & { a?: unknown[]; l?: number };
  }
}

type YmFunction = (
  counterId: number,
  method: string,
  ...args: unknown[]
) => void;

function ensureYmStub(): void {
  if (typeof window === "undefined" || window.ym) return;
  const stub = function (...args: unknown[]) {
    (stub.a = stub.a || []).push(args);
  } as YmFunction & { a?: unknown[]; l?: number };
  stub.l = Date.now();
  window.ym = stub;
}

/** Цель Метрики; повтор при асинхронной загрузке tag.js */
export function reachYandexGoal(goal: string, retry = 0): void {
  if (typeof window === "undefined") return;
  const maxAttempts = 20;
  const delayMs = 300;

  try {
    ensureYmStub();
    const ym = window.ym;
    if (ym?.a && retry < maxAttempts) {
      window.setTimeout(() => reachYandexGoal(goal, retry + 1), delayMs);
      return;
    }
    ym?.(YANDEX_METRIKA_COUNTER_ID, "reachGoal", goal);
  } catch {
    /* ignore */
  }
}

export function reachGoalAiChatSent(): void {
  reachYandexGoal("ai_chat_sent");
}

export function reachGoalAiChatSearch(): void {
  reachYandexGoal("ai_chat_search");
}
